import { useMemo } from "react";
import { useExperiment } from "@hopper-b2b/experiments";
import { I18nMarkup, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import dayjs from "dayjs";

import { EXPERIMENTS } from "../../App";
import CoinRotated from "../../assets/client/coin-rotated.svg?react";
import Coin from "../../assets/client/coin.svg?react";
import { useEnhancedEarnAmount } from "../../hooks/shared";
import styles from "./BlackFridayBanner.module.scss";

interface BlackFridayBannerProps {
  className?: string;
  variant?: "flight" | "hotel";
}

export const BlackFridayBanner = ({
  className,
  variant = "flight",
}: BlackFridayBannerProps) => {
  const { formatNumber, t } = useI18nContext();
  const blackFridayEnabled = useExperiment(EXPERIMENTS.NUBANK_BLACK_FRIDAY);
  const { cashbackPercent, pointsPerDollar } = useEnhancedEarnAmount();

  if (!blackFridayEnabled) {
    return null;
  }

  const IconComponent = variant === "hotel" ? Coin : CoinRotated;

  const tKey =
    variant === "hotel"
      ? "blackFriday.lodging.cashbackDescription"
      : "blackFriday.flight.cashbackDescription";

  return (
    <div className={clsx(styles.blackFridayBanner, styles[variant], className)}>
      <div
        className={clsx(styles.blackFridayBannerIconContainer, styles[variant])}
      >
        <IconComponent className={styles.icon} />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.title}>{t("blackFriday.title")}</div>
        <I18nMarkup
          className={styles.defaultText}
          tKey={tKey}
          replacements={{
            cashbackPercent: formatNumber(cashbackPercent, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 1,
            }),
            pointsPerDollar: formatNumber(pointsPerDollar, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }),
          }}
        />
      </div>
    </div>
  );
};
